import { render, staticRenderFns } from "./SalesOverviewFilter.vue?vue&type=template&id=36d0d430"
import script from "./SalesOverviewFilter.vue?vue&type=script&lang=ts"
export * from "./SalesOverviewFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports